import React from "react";
import '../../css/Home.css';
import { Link } from 'react-router-dom';
import "bootstrap-icons/font/bootstrap-icons.css";

const industries = [
  { icon: "bi-car-front-fill", title: "Automotive", desc: "Transportation and logistics services to optimise supply chains and meet tighter production schedules." },
  { icon: "bi-laptop", title: "Technology", desc: "End-to-end, integrated and reliable supply chain solutions to link production sites with distribution channels across the world." },
  { icon: "bi-heart-pulse", title: "Healthcare", desc: "Dedicated teams and a wide range of solutions to ensure compliance with quality standards and regulations." },
  { icon: "bi-building-gear", title: "Industrial", desc: "Tailor-made solutions to manage complex demands and make supply chains leaner and more agile." },
  { icon: "bi-cart", title: "Consumer", desc: "Transport to warehouse, distribution centre or direct-to-store so goods can reach the retailers directly." },
];

const IndustryFreightPage = () => {
  return (
    <>
      <div className="container text-center" id="divindustriesall">
        <h1 className="fw-bold mb-5" id="headingfreightforwarding">
          Whatever your industry, we are your global freight forwarder
        </h1>

        <div className="row g-4">
          {industries.map((ind, idx) => (
            <div className="col-12 col-md-6 col-lg-4" key={idx} id="industrysectiondiv">
              <div className="card p-4 hover-card">
                <i className={`bi ${ind.icon} w-25 mx-auto mb-3 icon`} style={{ fontSize: '3rem' }} />
                <h2 className="h5 mb-2" id="headingfreightforwarding">{ind.title}</h2>
                <p className="text-muted small mb-0">{ind.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <h3 className="text-secondary mt-5 mb-1 fw-semibold">In a different industry?</h3>
        <h3 className="text-secondary fw-bold">NO PROBLEM</h3>
      </div>

      <div className="button-wrapper" id="divbuttonindustries">
        <Link to="/contact-us" className="button-home-front">Book an appointment</Link>
      </div>
    </>
  );
};

export default IndustryFreightPage;